// extracted by mini-css-extract-plugin
export default {"hidden":"LogicalConnectionSelector_hidden__rdgGZ","selected":"LogicalConnectionSelector_selected__FIqVj"};